<template>
  <q-page padding>
    <div class="row col-12 justify-between items-center">
      <span class="text-h6 text-weight-bold text-brand-5 texto-titulo">
        Criar Nova Ferramenta no Catálogo
      </span>
      <router-link :to="{ name: 'ferramentaria-catalogo' }">
        <div
          style="cursor: pointer"
          class="row items-center text-weight-bold text-brand-5 container-link-voltar q-mr-md"
        >
          <q-icon class="q-mr-sm icon-texto" name="west" color="brand-5" />
          <span class="texto-titulo">Voltar</span>
        </div>
      </router-link>
    </div>
    <div class="row col-12 q-mt-xl">
      <div
        class="row col-md-9 col-xs-12 container-col-inputs text-brand-5 text-weight-bold"
      >
        <div class="row col-12 q-mt-sm">
          <div class="col-md col-xs">
            <div class="texto-titulo-input">Unidade</div>
            <ListaUnidadesSelect />
          </div>
          <div class="col-md col-xs q-ml-xs">
            <div class="texto-titulo-input">Código*</div>
            <q-input
              v-model="dadoFerramenta.codigo"
              class="input-mobile"
              dense
              maxlength="50"
              outlined
            />
          </div>
          <div class="col-md-12 col-xs-12 q-mt-sm espacamento-linha-input">
            <div class="texto-titulo-input">Descrição*</div>
            <q-input
              v-model="dadoFerramenta.nome"
              class="input-mobile"
              dense
              maxlength="256"
              outlined
            />
          </div>
        </div>
        <div class="row col-12 q-mt-sm">
          <div class="col-md col-xs">
            <div class="texto-titulo-input">Tempo de Permanência (min)</div>
            <q-input
              v-model="dadoFerramenta.tempoPermanencia"
              min="1"
              dense
              type="number"
              outlined
            />
          </div>
          <div class="col-md col-xs q-ml-xs alinhar-horizntal">
            <div class="texto-titulo-input">Unidade de Medida*</div>
            <q-input
              v-model="dadoFerramenta.unidadeMedida"
              class="input-mobile"
              dense
              maxlength="10"
              outlined
            />
          </div>
        </div>
        <div class="row col-12 q-mt-sm">
          <div class="col-md col-xs">
            <div class="texto-titulo-input">Grupo*</div>
            <SelecaoGrupo
              @enviarGrupo="receberGrupo"
              :grupoUuid="subgrupo?.catalogoGrupoUuid"
            />
          </div>
          <div class="col-md col-xs q-ml-xs">
            <div class="texto-titulo-input">Sub Grupo*</div>
            <SelecaoSubgrupo
              @enviarSubgrupo="receberSubgrupo"
              :grupoUuid="grupo?.catalogoGrupoUuid"
            />
          </div>
        </div>
        <div class="row col-12 q-mt-sm items-center no-wrap">
          <div class="col-md col-xs">
            <div class="texto-titulo-input q-mb-xs">Checklist*</div>
            <SelecaoChecklist
              @enviarChecklist="receberChecklist"
              :resetar="resetar"
              :multiple="false"
            />
          </div>
          <div>
            <p></p>
            <q-btn
              icon="add"
              dense
              class="q-mt-xs"
              flat
              color="primary"
              round
              @click="adicionarLinhaChecklist()"
            />
          </div>
        </div>
        <div
          class="row col-12 q-mt-sm no-wrap items-center"
          v-for="(checklist, index) in arrayChecklist"
          :key="index"
        >
          <div class="col-md col-xs">
            <q-input
              class="input-mobile"
              v-model="checklist.nome"
              dense
              disable
              outlined
            />
          </div>
          <div>
            <q-btn
              icon="delete"
              dense
              flat
              round
              color="red"
              @click="removerIndiceChecklist(index)"
            />
          </div>
        </div>
        <div class="row col-12 q-mt-sm no-wrap items-center">
          <div class="col">
            <div class="texto-titulo-input q-mb-xs">Acessório</div>
            <q-input
              class="input-mobile"
              v-model="acessorioCriar.nome"
              dense
              hide-bottom-space
              :rules="[validacaoCaracteresEspeciais]"
              outlined
            />
          </div>
          <div>
            <p
              v-if="
                validacaoCaracteresEspeciais(acessorioCriar.nome) !=
                'Caracteres especiais não são permitidos.'
              "
            ></p>
            <q-btn
              icon="add"
              class="q-mt-xs"
              dense
              flat
              color="primary"
              round
              @click="adicionarLinhaAcessorio()"
            />
          </div>
        </div>
        <div
          class="row col-12 q-mt-sm no-wrap items-center"
          v-for="(acessorio, index) in acessorios"
          :key="index"
        >
          <div class="col">
            <q-input
              class="input-mobile"
              v-model="acessorio.nome"
              dense
              outlined
              disable
            />
          </div>
          <div>
            <q-btn
              icon="delete"
              dense
              flat
              round
              color="red"
              @click="removerIndiceAcessorio(index)"
            />
          </div>
        </div>
        <div class="row col-12 q-mt-sm no-wrap">
          <div class="col-md-2 col-xs-6">
            <div class="texto-titulo-input q-mb-xs">Atributo</div>
            <q-input
              class="input-mobile"
              v-model="atributoCriar.chave"
              dense
              outlined
              hide-bottom-space
              :rules="[validacaoCaracteresEspeciais]"
            />
          </div>
          <div class="col-md-4 col-xs q-ml-xs espacamento">
            <q-input
              class="input-mobile"
              v-model="atributoCriar.valor"
              dense
              hide-bottom-space
              :rules="[validacaoCaracteresEspeciais]"
              outlined
            />
          </div>
          <div>
            <q-btn
              icon="add"
              dense
              flat
              color="primary"
              round
              class="icon"
              @click="adicionarLinhaAtributo()"
            />
          </div>
        </div>
        <div
          class="row col-12 q-mt-sm no-wrap items-center"
          v-for="(atributo, index) in atributosFerramentas"
          :key="index"
        >
          <div class="col-md-2 col-xs-6">
            <q-input
              class="input-mobile"
              v-model="atributo.chave"
              dense
              outlined
              disable
            />
          </div>
          <div class="col-md-4 col-xs q-ml-xs">
            <q-input
              class="input-mobile"
              v-model="atributo.valor"
              dense
              outlined
              disable
            />
          </div>
          <div>
            <q-btn
              icon="delete"
              dense
              flat
              round
              color="red"
              @click="removerIndiceAtributo(index)"
            />
          </div>
        </div>
      </div>
      <div class="col-md col-xs-12 container-col-imagem">
        <div class="container-imagem">
          <q-img
            class="imagem-ferramenta"
            fit="contain"
            :src="preVisualizacaoImg"
          >
            <div class="file-container">
              <q-file
                style="width: 100% !important; height: 200px"
                borderless
                type="file"
                v-model="img"
              >
                <div
                  class="row col-12 justify-center items-center texto-imagem"
                >
                  <span
                    v-if="
                      (dadoFerramenta.url == null && img?.name == '') ||
                      img?.name == undefined
                    "
                    class="texto-alterar-imagem"
                    >{{
                      dadoFerramenta.url == null ? "Adicionar Imagem" : ""
                    }}</span
                  >
                  <span class="texto-alterar-imagem">{{
                    img?.name ? "" : ""
                  }}</span>
                </div>
              </q-file>
            </div>
            <div
              v-if="preVisualizacaoImg != ''"
              style="
                width: 100%;
                top: 0;
                background: transparent;
                cursor: pointer;
              "
              class="absolute row col-12 justify-between items-center"
            >
              <q-icon
                class="absolute all-pointer-events"
                size="25px"
                color="red"
                style="top: 8px; right: 16px; z-index: 30"
                name="delete"
                @click="(preVisualizacaoImg = ''), (img = null)"
              ></q-icon>
            </div>
          </q-img>
        </div>
      </div>
    </div>
    <div class="row q-mt-xl col-12 q-gutter-sm container-btn">
      <div>
        <q-btn
          icon="check_circle_outline"
          class="btn"
          label="Salvar"
          color="positive"
          no-caps
          @click="criarFerramenta()"
        />
      </div>
      <div>
        <router-link :to="{ name: 'ferramentaria-catalogo' }">
          <div style="cursor: pointer">
            <q-btn
              icon="cancel"
              class="btn"
              label="Cancelar"
              color="negative"
              no-caps
            />
          </div>
        </router-link>
      </div>
    </div>
  </q-page>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import { salvarCatalogoUuid } from "../composables/salvarCatalogoUuid";

import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import SelecaoChecklist from "../components/SelecaoChecklist.vue";
import SelecaoGrupo from "../components/SelecaoGrupo.vue";
import SelecaoSubgrupo from "../components/SelecaoSubgrupo.vue";

export default {
  components: {
    ListaUnidadesSelect,
    SelecaoChecklist,
    SelecaoGrupo,
    SelecaoSubgrupo,
  },
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    const router = useRouter();

    const catalogoUuid = salvarCatalogoUuid();
    const img = ref(null);
    const atributosFerramentas = ref([]);
    const acessorios = ref([]);
    const dadoFerramenta = ref({
      catalogoSubGrupoUuid: "",
      codigo: "",
      nome: "",
      unidadeMedida: "",
      urlImagem: "",
      tempoPermanencia: "",
      atributos: [],
      checkLists: [],
    });
    const checklistFerramenta = ref([]);
    const resetar = ref(0);
    const grupo = ref({});
    const subgrupo = ref({});
    const preVisualizacaoImg = ref("");
    const imgBase64 = ref("");
    const urlImagem = ref("");
    const arrayChecklist = ref([]);
    const atributoCriar = ref({ chave: "", valor: "" });
    const acessorioCriar = ref({ nome: "" });

    const criarFerramenta = async () => {
      if (dadoFerramenta.value.codigo === "") {
        quasar.notify({
          message: "O campo código não pode estar vazio.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (dadoFerramenta.value.nome === "") {
        quasar.notify({
          message: "O campo descrição não pode estar vazio.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (dadoFerramenta.value.unidadeMedida === "") {
        quasar.notify({
          message: "O campo Unidade de medida não pode estar vazio.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (dadoFerramenta.value.catalogoSubGrupoUuid === "") {
        quasar.notify({
          message: "O campo Subgrupo não pode estar vazio.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (arrayChecklist.value.length === 0) {
        quasar.notify({
          message: "Selecione ao menos um checklist.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        const response = await store.dispatch("ferramentaria/adicionarItem", {
          catalogoSubGrupoUuid: dadoFerramenta.value.catalogoSubGrupoUuid,
          codigo: dadoFerramenta.value.codigo,
          nome: dadoFerramenta.value.nome,
          unidadeMedida: dadoFerramenta.value.unidadeMedida,
          urlImagem: urlImagem.value,
          acessorios: acessorios.value,
          tempoPermanencia: parseInt(dadoFerramenta.value.tempoPermanencia),
          atributos: atributosFerramentas.value,
          checkLists: arrayChecklist.value,
          usuarioId: store.state.autenticacao.usuarioLogado.id,
          usuarioNome: store.state.autenticacao.usuarioLogado.nome,
        });
        quasar.notify({
          message: "Ferramenta criada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        if (img.value != null) {
          let uuidItemCatalogo =
            response.response.data.resultado.catalogoItemUuid;
          await fazerUploadImagem(uuidItemCatalogo);
        }
        router.push({ name: "ferramentaria-catalogo" });
      } catch (error) {
        if (error.response?.data?.erro?.detalhes) {
          for (const key in error.response?.data?.erro?.detalhes) {
            if (
              Object.hasOwnProperty.call(
                error.response?.data?.erro?.detalhes,
                key
              )
            ) {
              const element = error?.response?.data?.erro?.detalhes[key];
              quasar.notify({
                message: `${key.charAt(0).toUpperCase()}${key.substring(
                  1
                )} ${element}`,
                color: "negative",
                actions: [
                  {
                    label: "Fechar",
                    color: "white",
                    handler: () => {
                      /* ... */
                    },
                  },
                ],
              });
            }
          }
        }
        if (
          error?.response?.data?.erro?.mensagem &&
          error?.response?.data?.erro?.mensagem !=
            "Solicitacao incorreta, verifique 'detalhes' para mais informacao"
        ) {
          quasar.notify({
            message: error.response?.data?.erro?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error?.response?.data?.erros?.mensagem) {
          quasar.notify({
            message: error.response?.data?.erros?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const adicionarLinhaAtributo = () => {
      if (
        validacaoCaracteresEspeciais(atributoCriar.value.chave) != true ||
        validacaoCaracteresEspeciais(atributoCriar.value.valor) != true
      ) {
        return;
      }
      if (atributoCriar.value.chave == "") {
        quasar.notify({
          message: "O campo chave do atributo não pode ser vazio.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (atributoCriar.value.valor == "") {
        quasar.notify({
          message: "O campo valor do atributo não pode ser vazio.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (
        atributosFerramentas.value.some(
          (atributo) => atributoCriar.value.chave == atributo.chave
        )
      ) {
        quasar.notify({
          message: "Já existe um atributo com a mesma chave adicionado.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      atributosFerramentas.value.push({
        chave: atributoCriar.value.chave,
        valor: atributoCriar.value.valor,
      });
      atributoCriar.value = {
        chave: "",
        valor: "",
      };
    };

    const adicionarLinhaAcessorio = () => {
      if (validacaoCaracteresEspeciais(acessorioCriar.value.nome) != true) {
        return;
      }
      if (acessorioCriar.value.nome == "") {
        quasar.notify({
          message: "O campo não pode ser vazio.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      acessorios.value.push({ nome: acessorioCriar.value.nome });
      acessorioCriar.value.nome = "";
    };

    const verificarIndiceAtributo = (index) => {
      return atributosFerramentas.value[index + 1];
    };

    const verificarIndiceAcessorio = (index) => {
      return acessorios.value[index + 1];
    };

    const removerIndiceAtributo = (index) => {
      atributosFerramentas.value.splice(index, 1);
    };

    const removerIndiceAcessorio = (index) => {
      acessorios.value.splice(index, 1);
    };

    const receberChecklist = (value) => {
      dadoFerramenta.value.checkLists = value;
    };

    const validacaoCaracteresEspeciais = (val) => {
      const regex = /[^a-zA-Z0-9\s]/g; // Expressão regular para caracteres especiais

      if (regex.test(val)) {
        return "Caracteres especiais não são permitidos.";
      } else {
        return true; // Validação passou
      }
    };

    const adicionarLinhaChecklist = () => {
      if (arrayChecklist.value.length > 0) {
        let valido = arrayChecklist.value.some(
          (value) =>
            value.checkListUuid == dadoFerramenta.value.checkLists.checkListUuid
        );
        if (valido) {
          quasar.notify({
            message: "Checklist já adicionado.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
      }
      if (
        dadoFerramenta.value?.checkLists?.checkListUuid == "" ||
        dadoFerramenta.value?.checkLists?.checkListUuid == undefined
      ) {
        quasar.notify({
          message: "Selecione um checklist.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      arrayChecklist.value.push({
        checkListUuid: dadoFerramenta.value.checkLists.checkListUuid,
        nome: dadoFerramenta.value.checkLists.nome,
        descricao: dadoFerramenta.value.checkLists.descricao,
      });
      resetar.value++;
    };

    const removerIndiceChecklist = (index) => {
      arrayChecklist.value.splice(index, 1);
    };

    const receberGrupo = (value) => {
      grupo.value = value;
    };

    const receberSubgrupo = (value) => {
      subgrupo.value = value;
      dadoFerramenta.value.catalogoSubGrupoUuid = value?.catalogoSubGrupoUuid;
    };

    const fazerUploadImagem = async (catalogoItemUuid) => {
      try {
        const response = await store.dispatch(
          "ferramentaria/receberUrlUpload",
          {
            catalogoItemUuid: catalogoItemUuid,
            nomeArquivo: img.value.name,
          }
        );

        let formAttributes =
          response.response.data.resultado.dados.formAttributes;
        let formInputs = response.response.data.resultado.dados.formInputs;
        const formData = new FormData();

        for (let input in formInputs) {
          formData.append(input, formInputs[input]);
        }

        formData.append("file", img.value);
        var request = new XMLHttpRequest();
        request.open(formAttributes.method, formAttributes.action);
        request.send(formData);
        urlImagem.value = `${formAttributes.action}/${formInputs.key}`;
        await finalizarUploadImagem(catalogoItemUuid);
      } catch (error) {
        console.log(error);
      }
    };

    const finalizarUploadImagem = async (catalogoItemUuid) => {
      try {
        await store.dispatch("ferramentaria/editarItem", {
          catalogoItemUuid: catalogoItemUuid,
          urlImagem: urlImagem.value,
        });
      } catch (error) {
        console.log(error);
      }
    };

    watch(
      () => img.value,
      () => {
        if (img.value == null) {
          return;
        }
        if (img.value == null || !img.value.type.includes("image")) {
          quasar.notify({
            message: "Selecione uma imagem",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          preVisualizacaoImg.value = "";
          img.value = null;
          return;
        }
        let fileReader = new FileReader();

        fileReader.readAsDataURL(img.value);
        fileReader.addEventListener("load", () => {
          imgBase64.value = fileReader.result;
          preVisualizacaoImg.value = fileReader.result;
        });
      }
    );

    watch(
      () => dadoFerramenta.value.tempoPermanencia,
      (atual, antigo) => {
        if (atual.length > 6 && antigo.length == 6) {
          quasar.notify({
            message: `O campo "Tempo de Permanência" não pode ter mais que 6 digitos.`,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          dadoFerramenta.value.tempoPermanencia = antigo;
        }
      }
    );

    return {
      criarFerramenta,
      img,
      atributosFerramentas,
      adicionarLinhaAtributo,
      verificarIndiceAtributo,
      removerIndiceAtributo,
      dadoFerramenta,
      checklistFerramenta,
      receberChecklist,
      resetar,
      grupo,
      subgrupo,
      receberGrupo,
      receberSubgrupo,
      preVisualizacaoImg,
      adicionarLinhaAcessorio,
      imgBase64,
      fazerUploadImagem,
      catalogoUuid,
      arrayChecklist,
      adicionarLinhaChecklist,
      acessorioCriar,
      removerIndiceChecklist,
      acessorios,
      verificarIndiceAcessorio,
      removerIndiceAcessorio,
      atributoCriar,
      validacaoCaracteresEspeciais,
    };
  },
};
</script>

<style scoped>
/* Estilo CSS para o texto de erro */
.q-field__messages {
  display: none;
}

.q-field__messages.q-field__messages--standard {
  display: block;
  margin-top: 4px; /* Espaçamento superior personalizado quando há erro */
  font-size: 12px; /* Tamanho de fonte personalizado */
  color: blue; /* Cor do texto de erro personalizada */
}
.imagem-ferramenta-container {
  border: 1px solid black;
}
.imagem-ferramenta {
  width: 100%;
  height: 100%;
}
.container-imagem {
  height: 100%;
  max-height: 380px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #707070;
  border-radius: 10px;
  overflow: hidden;
}
.file-container {
  width: 100%;
  background: transparent;
  z-index: 30 !important;
}
.texto-alterar-imagem {
  color: black !important;
  z-index: 31;
  cursor: pointer;
  transition: all 0.5s;
}
.texto-alterar-imagem:hover {
  transform: scale(1.1);
}
a {
  text-decoration: none;
}
.icon {
  margin-top: 27px;
}
.espacamento {
  margin-top: 25px;
}
.texto-titulo {
  font-size: 20px;
}
.icon-texto {
  font-size: 25px;
}
.container-col-imagem {
  margin: 27px 0px 0px 0px;
  padding: 0px 0px 0px 5px;
}
.container-col-inputs {
  padding: 0px 5px 0px 0px;
}
.texto-imagem {
  height: 280px;
  width: 100%;
}
@media (max-width: 1024px) {
  .container-col-imagem {
    margin-top: 18px;
    padding: 0px;
  }
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .texto-titulo-input {
    font-size: 12px;
  }
  .sem-margin {
    margin-left: 1px;
  }
  .espacamento-linha-input {
    margin-top: 8px;
  }
  .container-link-voltar {
    margin-right: 0px;
  }
  .icon-texto {
    font-size: 20px;
    margin-right: 1px;
  }
  .espacamento {
    margin-top: 22px;
  }
  .container-btn {
    justify-content: center;
  }
  .btn {
    font-size: 13px;
  }
  .input-mobile {
    font-size: 12px;
  }
  .texto-imagem {
    height: 160px;
    width: 100%;
  }
  .imagem-ferramenta {
    width: 100%;
    height: 100%;
  }
  .container-imagem {
    height: 100%;
    min-height: 220px;
    max-height: 220px;
  }
}
@media (max-width: 365px) {
  .alinhar-horizntal {
    margin-top: 18px;
  }
}
</style>
